<template>
  <div>
    <BaseFormLabel
      v-if="label"
      :name="name"
      :label="label"
      :note="note"
      :required="required"
    />

    <div
      v-if="toggleSelectAll"
      class="text-right items-start justify-between mb-2"
    >
      <label class="text-xs">
        <input
          type="button"
          :disabled="disabled"
          :class="[
            disabled
              ? 'text-gray-62 bg-transparent underline'
              : 'bg-transparent cursor-pointer underline hover:no-underline',
          ]"
          value="すべて選択/解除"
          @click="toggleSelectAll"
        />
      </label>
    </div>

    <div class="flex flex-wrap">
      <div v-for="option in options" :key="option.id" class="mb-4 pr-3 w-1/3">
        <Field
          v-slot="{ field, value }"
          type="checkbox"
          :name="name"
          :value="option.id"
          :validateOnMount="true"
        >
          <BaseCheckbox
            :name="name"
            :field="field"
            :value="option.id"
            :checked="value && value.indexOf(option.id) !== -1"
            :disabled="disabled"
            :on-change="setDirty"
          >
            {{
              optionFormatType === 'number'
                ? amountFormatter(option.name)
                : option.name
            }}{{ unit }}
          </BaseCheckbox>
        </Field>
      </div>
    </div>

    <BaseErrorMessage v-if="isDirty" :name="name" />
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue';
import { Field } from 'vee-validate';

import { amountFormatter } from '@/utils/filters.js';
import BaseFormLabel from '@/components/form/BaseFormLabel.vue';
import BaseCheckbox from '@/components/form/BaseCheckbox.vue';
import BaseErrorMessage from '@/components/form/BaseErrorMessage.vue';

export default {
  components: {
    Field,
    BaseFormLabel,
    BaseCheckbox,
    BaseErrorMessage,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    formatType: {
      type: String,
      default: '',
    },
    optionFormatType: String,
    unit: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ['select-all'],
  setup(props, { emit }) {
    const state = reactive({
      isDirty: false,
      isSelectedAll: false,
    });

    const setDirty = () => {
      state.isDirty = true;
    };

    const toggleSelectAll = () => {
      const value = state.isSelectedAll
        ? []
        : props.options.map((option) => option.id);

      state.isDirty = true;
      state.isSelectedAll = !state.isSelectedAll;
      emit('select-all', { name: props.name, value });
    };

    return {
      ...toRefs(state),
      amountFormatter,
      setDirty,
      toggleSelectAll,
    };
  },
};
</script>

<style lang="scss" scoped></style>
